import { Fragment } from 'react'
import { NextSeo, ArticleJsonLd } from 'next-seo'
import { useRouter } from 'next/router'

import NavigationBar from '@/components/NavigationBar'
import Footer from '@/components/Footer'

import Contact from '@/features/landing/templates/Contact'
import BlogContent from '@/features/blogs/templates/Blog/BlogContent'
import { Blog } from '@/features/blogs/types/blog'

import env from '@/lib/env'

export interface BlogProps {
  blog: Blog
}

function BlogPage({ blog }: BlogProps): React.ReactElement {
  const router = useRouter()

  return (
    <Fragment>
      <NextSeo
        title={blog.meta_title}
        description={blog.meta_description}
        openGraph={{
          title: blog.meta_title,
          description: blog.meta_description,
          type: 'article',
          images: [
            {
              url: blog.image.original,
              alt: blog.meta_title,
            },
          ],
          article: {
            publishedTime: blog.published_at,
            authors: [blog.meta_author],
            tags: (blog.meta_keywords ?? '').split(/,/i),
          },
        }}
        additionalMetaTags={[
          {
            property: 'author',
            content: blog.meta_author,
          },
          {
            name: 'keywords',
            content: blog.meta_keywords,
          },
        ]}
      />
      <ArticleJsonLd
        url={`${env.APP_URL}${router.asPath}`}
        title={blog.meta_title}
        images={[blog.image.original]}
        datePublished={blog.published_at}
        authorName={[blog.meta_author]}
        description={blog.meta_description}
      />
      <NavigationBar />
      <BlogContent blog={blog} />
      <Contact />
      <Footer />
    </Fragment>
  )
}

export default BlogPage
